//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import {
  DraftQuerySortBy,
  IDraftPost,
} from '@apis/universal-posts/draft-posts/universalDraftPostsApiModel';
import DraftId from '@models/DraftId';
import { Normalized } from '@utils/normalize';

export interface IUniversalDraftsState {
  // Data
  draftPosts: NormalizedDraftPosts;
  totalCount: number | undefined;

  // Configuration
  searchOffset: number;
  sortBy: DraftQuerySortBy;

  // Modals
  deleteDraftModal: {
    currentDraftIds: DraftId[];
    isOpen: boolean;
  };

  errors: {
    deleteDraftPostError: string | undefined;
    fetchAdditionalDraftPostsError: string | undefined;
    fetchDraftPostsError: string | undefined;
    fetchDraftPostByIdError: string | undefined;
  };
  flags: {
    hasReachedEndOfDraftPosts: boolean;
    isDeletingDraftPost: boolean;
    isFetchingAdditionalDraftPosts: boolean;
    isFetchingDraftPosts: boolean;
    isFetchingDraftPostById: boolean;
  };
}

export type NormalizedDraftPosts = Normalized<IDraftPost, DraftId>;

export const SEARCH_DRAFT_POSTS_REQUEST_LIMIT = 24;
